import { render, staticRenderFns } from "./simples_nacional.vue?vue&type=template&id=4b2bb49d&scoped=true&"
import script from "./simples_nacional.vue?vue&type=script&lang=js&"
export * from "./simples_nacional.vue?vue&type=script&lang=js&"
import style0 from "./simples_nacional.vue?vue&type=style&index=0&id=4b2bb49d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bb49d",
  null
  
)

export default component.exports